import React, {useContext, useEffect, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import queryString from "query-string";
import {Context} from "../../state/context";
import {STATUS_LIST} from "../../enums/key-status-list";
import {ROLE} from '../../enums/roles';
import {hasRole} from '../../utils/hasRole';

import './keys-left-panel.styles.scss';
import KeyItem from '../key-item/key-item.component';
import KeyItemStatus from '../key-item-status/key-item-status.component';
import AddTranslationForm
  from '../add-translation-form/add-translation-form.component';
import useFetch from '../../api/fetch';
import useGetKeys from '../../api/keys';
import useGetTags from '../../api/tags';
import useGetCategories from '../../api/categories';
import {KEY_STATUS} from "../../enums/key-status";
import {PLATFORM_ICONS, PLATFORM_NAMES} from '../../enums/platforms';

export default function KeysLeftPanel({ languages }) {
    const { state, dispatch } = useContext(Context);
    const { language } = useParams();
    const getKeys = useGetKeys();
    const getTags = useGetTags();
    const getCategories = useGetCategories();
    const fetch = useFetch();

    const [keys, setKeys] = useState([]);
    const [displayForm, setDisplayForm] = useState(false);
    const [importLoading, setImportLoading] = useState(false);
    const [file, setFile] = useState([]);
    const [failedImportedKeys, setFailedImportedKeys] = useState([]);
    const [importStatus, setImportStatus] = useState(null);
    const [importError, setImportError] = useState(null);
    const [keysStatus, setKeysStatus] = useState(KEY_STATUS.PUBLISHED);
    const [selectedLanguage, setSelectedLanguage] = useState(language);
    const [selectedLanguageName, setSelectedLanguageName] = useState("");
    const [permalinkKey, setPermalinkKey] = useState("");
    const [roles, setRoles] = useState([]);
    const [search, setSearch] = useState("");
    const [platforms, setPlatforms] = useState({
        'platform::vr': 'platform::vr',
        'platform::android': 'platform::android',
        'platform::ios': 'platform::ios',
        'platform::web': 'platform::web',
        'platform::marketing': 'platform::marketing',
        'platform::braze': 'platform::braze',
    });
    const [platformNone, setPlatformNone] = useState(true);
    const [statuses, setStatuses] = useState({});

    useEffect(() => {
        const queryValues = queryString.parse(window.location.search);
        if(queryValues.key && queryValues.key.length > 0) {
            setPermalinkKey(queryValues.key);
        }
        (async () => {
            const tags = await getTags();
            const platformTags = tags.filter(tag => Object.keys(platforms).includes(tag.name))
            const regularTags = tags.filter(tag => !Object.keys(platforms).includes(tag.name))

            dispatch({ type: 'SET_TAGS', tags: regularTags });
            dispatch({ type: 'SET_PLATFORM_TAGS', platformTags: platformTags });
        })();
        (async () => {
            const categories = await getCategories();
            dispatch({ type: 'SET_CATEGORIES', categories: categories });
        })();
    }, []);

    useEffect(() => {
        if(permalinkKey.length > 0 && keys.length > 0) {
            const selectedKey = keys.find(key => key.text.toLowerCase() === permalinkKey.toLowerCase());
            if(selectedKey) {
                dispatch({ type: 'SET_ACTIVE_KEY', activeKey: { id: selectedKey.id, text: selectedKey.text, status: selectedKey.key_status, deadline: selectedKey.due_to } });
            }
        }
    }, [keys, permalinkKey])

    useEffect(() => {

        if (languages && languages.length > 0) {
            const languageName = languages.find(lang => lang.tag == selectedLanguage).name;
            setSelectedLanguageName(languageName);
        }
    }, [languages]);


    useEffect(() => {
        if (languages && languages.length > 0) {
            const languageName = languages.find(lang => lang.tag == selectedLanguage).name;
            setSelectedLanguageName(languageName);
        }
        setKeys([]);
        dispatch({ type: 'SET_LANGUAGE', language: selectedLanguage });
        (async () => {
            const keys = await getKeys(selectedLanguage, KEY_STATUS.PUBLISHED);
            const drafts = await getKeys(selectedLanguage, KEY_STATUS.DRAFT);
            const deleted = await getKeys(selectedLanguage, KEY_STATUS.DELETED);
            dispatch({ type: 'SET_DELETED', deleted });
            dispatch({ type: 'SET_DRAFTS', drafts });
            dispatch({ type: 'SET_KEYS', keys });
        })();
    }, [selectedLanguage]);

    useEffect(() => {
        setSelectedLanguage(language);
    }, [language]);

    useEffect(() => {
        setRoles(state.roles)
    }, [state.roles])

    useEffect(() => {
        const kStatus = parseInt(keysStatus);
        if (kStatus === KEY_STATUS.PUBLISHED) {
            setKeys(state.keys);
        } else if (kStatus === KEY_STATUS.DRAFT) {
            setKeys(state.drafts);
        } else if (kStatus === KEY_STATUS.DELETED) {
            setKeys(state.deleted);
        }
    }, [state.keys, state.drafts, state.deleted, keysStatus]);

    useEffect(() => {
        if (file.length > 0) {
            setImportLoading(true);
            importXlsx(file[0]);
        }
    }, [file]);


    const handleStatusChange = (e) => {
        let value = e.target.value.toString();

        if (e.target.checked) {
            statuses[value] = STATUS_LIST[value];
        } else {
            delete statuses[value];
        }
        setStatuses({ ...statuses });
    }

    const handlePlatformChange = (e) => {
        let value = e.target.value.toString();

        if (e.target.checked) {
            platforms[value] = value;
        } else {
            delete platforms[value];
        }
        setPlatforms({ ...platforms });
    }

    const displayFilterResults = (s, p, st) => {
        const selectedStatusFilters = Object.keys(st).map(k => parseInt(k));
        const filtered = keys
            .filter(
                ({ all_tags }) => {
                    // If there is no platform tag set, and the platformNone filter is active, return true
                    if (platformNone && all_tags.filter((p) => Object.keys(PLATFORM_NAMES).includes(p)).length === 0) {
                      return true;
                    }

                    if (Object.keys(platforms).length > 0) {
                        return all_tags.filter((p) => Object.keys(platforms).includes(p)).length > 0;
                    }
                    return false;
                }
            )
            .filter(({ text, target }) => text.toLowerCase().includes(s.toLowerCase()) || (target && target.toLowerCase().includes(s.toLowerCase())))
            .filter(
                ({ status }) => {
                  if (selectedStatusFilters.length > 0 && !selectedStatusFilters.includes(parseInt(status))) {
                    return false;
                  }
                  return true;
                }
            );

        if (filtered.length !== 0)
            return filtered.map((it, index) => <KeyItem key={index} keyItem={it} />);

        return <div>No results</div>
    };

  const showTranslationForm = () => {
    setDisplayForm(true);
    window.location.hash = '#add-translation-form';
    window.$('#add-translation-form').modal("show");
  }
  const hideTranslationForm = () => {
    setDisplayForm(false);
    window.$('#add-translation-form').modal("hide");
  }

  const createTranslation = async (formData) => {
    const result = await fetch("/api/key/create", {
      method: "POST",
      body: formData,
    }).then(res => res.json());
    return result;
  }

  const reloadKeysLeftPanel = () => {
      (async () => {
          const keys = await getKeys(selectedLanguage, KEY_STATUS.PUBLISHED);
          const drafts = await getKeys(selectedLanguage, KEY_STATUS.DRAFT);
          const deleted = await getKeys(selectedLanguage, KEY_STATUS.DELETED);
          dispatch({ type: 'SET_DELETED', deleted });
          dispatch({ type: 'SET_DRAFTS', drafts });
          dispatch({ type: 'SET_KEYS', keys });
      })();
  }

  const importXlsx = async (file) => {
    const data = new FormData();
    data.append('xlsx_file', file, file.name);

    const result = await fetch(`/api/key/import-xlsx`, {
        method: "POST",
        body: data
    }).then(x => x.json());

    if (result.success) {
        setFile([]);
        setImportStatus(true);
        setFailedImportedKeys(result.failed);
    }
    if (result.success === false) {
      setImportError(result.error);
      setImportStatus(false);
    }

    setImportLoading(false);
    document.getElementById('keys-import').value = null;
    window.$('#import-response').modal("show");

    reloadKeysLeftPanel()
    setKeysStatus(KEY_STATUS.DRAFT)
    setKeys(state.drafts);
  }

    return (
      <div className={"px-3"} id={"left"}>
          <div className="d-flex flex-column">
              {hasRole(roles, ROLE.ADMIN) && <><div className="row align-items-center mt-3">
                  <div className="dropdown col-5 dropdown-languages">
                      <a href="#" className="d-flex align-items-center justify-content-between w-100 dropdown-toggle" type="button" id="dropdownLanguages" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span className="d-inline-flex align-items-center">
                              <span className={`language-flag ${selectedLanguage}`}></span>
                              <span className='language-text'>{selectedLanguageName}</span>
                          </span>
                          <i className="fas fa-chevron-down"></i>
                      </a>
                      <div className="dropdown-menu scrollable-menu w-100" aria-labelledby="dropdownLanguages">
                          {languages && languages.map((language, index) => (
                              <NavLink className="dropdown-item d-flex align-items-center" key={index} to={{ pathname: `/translation/${language.tag}` }}>
                                <span className={`language-flag ${language.tag}`}></span> {language.name}
                              </NavLink>
                          ))}
                      </div>
                  </div>
                  <div className="col-3">
                      <a className="btn btn-mondly btn-outline-blue btn-block d-flex align-items-center justify-content-center" onClick={showTranslationForm} >Add key</a>
                  </div>
                  <div className="col-4">
                    {importLoading && <span className='notification-loader'>Importing ...</span>}
                    {!importLoading && <>
                      <input type="file" className="d-none" id="keys-import" onChange={e => setFile(e.currentTarget.files)} disabled={importLoading} />
                      <label htmlFor={'keys-import'} className="btn btn-mondly btn-outline-blue btn-block mt-2">Import Keys</label>
                    </>}

                  </div>
              </div>
              </>
              }
              <div className="input-group mt-3 search-field">
                  <input className={"form-control shadow-none border-right-0"}
                      placeholder={"Search"}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)} />
                  <div className="input-group-append">
                      <span className={"input-group-text bg-transparent border-left-0"}><i className="fas fa-search"></i></span>
                  </div>
              </div>
              {hasRole(roles, ROLE.ADMIN) &&
                  <div className="mt-3 d-flex justify-content-end">
                      <div className={"text-right"}>
                          {Object.keys(PLATFORM_ICONS).map((p, index) => (
                              <div key={index} className={"form-check-inline form-check platform-check-container"}>
                                  <input className="form-check-input platform-check d-none" type="checkbox"
                                      id={`platform-${p}`} onChange={handlePlatformChange} value={p} checked={Object.keys(platforms).includes(p)}/>
                                  <label className="form-check-label platform-label cursor-pointer text-light-gray"
                                      data-toggle="tooltip" data-placement="top" title={PLATFORM_NAMES[p]}
                                      htmlFor={`platform-${p}`}>
                                      <i className={`m-1 ${PLATFORM_ICONS[p]}`} />
                                  </label>
                              </div>
                          ))}

                        <div className={"form-check-inline form-check platform-check-container"}>
                          <input className="form-check-input platform-check d-none" type="checkbox"
                                 id="platform-none" onChange={(e) => {setPlatformNone(!platformNone)}} checked={platformNone}/>
                          <label className="form-check-label platform-label cursor-pointer text-light-gray"
                                 data-toggle="tooltip" data-placement="top" title="No platform"
                                 htmlFor="platform-none">
                            <i className="m-1 fas fa-question" />
                          </label>
                        </div>
                      </div>
                  </div>}
              <div className={`${hasRole(roles, ROLE.ADMIN) ? 'mt-3' : 'mt-4'} d-flex`}>
                  {Object.keys(STATUS_LIST).filter((status) => {
                      if(hasRole(roles, ROLE.ADMIN)) {
                          return true;
                      }
                      return !STATUS_LIST[status].restricted;
                  }).map((status, index) => (
                      <span className="mr-2" key={index}>
                          <input type="checkbox" onChange={handleStatusChange} value={status} className={"d-none status-checkbox"} id={`status-checkbox-${index}`} />
                          <label className={"d-inline-flex align-items-center py-1 status-label cursor-pointer"} htmlFor={`status-checkbox-${index}`}>
                              <KeyItemStatus status={status} />
                              <span className="ml-1">{STATUS_LIST[status].text}</span>
                          </label>
                      </span>

                  ))}
              </div>
          </div>

          {hasRole(roles, ROLE.ADMIN) &&
              <div className="row mt-3 mb-2">
                  <div className="col m-0 pr-0 cursor-pointer text-center translation-keys-status">
                      <input className="d-none" type="radio" name="translation_keys_status" id="published" checked={keysStatus === KEY_STATUS.PUBLISHED} onChange={() => setKeysStatus(KEY_STATUS.PUBLISHED)} />
                      <label className="d-block cursor-pointer py-2" htmlFor="published">Published</label>
                  </div>
                  <div className="col m-0 px-0 cursor-pointer text-center translation-keys-status">
                      <input className="d-none" type="radio" name="translation_keys_status" id="drafts" checked={keysStatus === KEY_STATUS.DRAFT} onChange={() => setKeysStatus(KEY_STATUS.DRAFT)} />
                      <label className="d-block cursor-pointer py-2" htmlFor="drafts">Drafts</label>
                  </div>
                  <div className="col m-0 pl-0 cursor-pointer text-center translation-keys-status">
                      <input className="d-none" type="radio" name="translation_keys_status" id="obsolete" checked={keysStatus === KEY_STATUS.DELETED} onChange={() => setKeysStatus(KEY_STATUS.DELETED)} />
                      <label className="d-block cursor-pointer py-2" htmlFor="obsolete">Obsolete</label>
                  </div>
              </div>}
          <section>
              <ul className="list-unstyled">
                  {displayFilterResults(search, platforms, statuses)}
              </ul>
          </section>
        <div className="modal fade" id="add-translation-form" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Add a new translation key</h3>
                <button type="button" className="close" aria-label="Close" onClick={hideTranslationForm}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {displayForm && <AddTranslationForm languageList={languages} hideForm={hideTranslationForm} createTranslation={createTranslation} reloadKeysLeftPanel={reloadKeysLeftPanel} />}
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="import-response" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    {importStatus && <>
                      <h4>Success!</h4>
                      {failedImportedKeys.length && <>
                        <h5>Failed keys:</h5>
                        {failedImportedKeys.map((error, index) => (
                          <div key={index}>{error}</div>
                        ))}
                      </>}
                    </>}
                    {!importStatus && <>
                      <h4 className="error">Error!</h4>
                      <div>{importError}</div>
                    </>}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-mondly btn-outline-blue" data-dismiss="modal" aria-label="Close">Close</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
}
